import React from "react";

import { Modal as AntModal, ModalProps as AntModalProps } from "antd";

import { ProductEventProps, productAnalytics, trackMixpanel } from "utils";

import { Input, InputPassword, InputProps, PageSpin, Typography } from "components";

export type ModalProps = AntModalProps &
  ProductEventProps & {
    dataTestId?: string;
    content?: React.ReactNode; // use this for custom content {ReactNode}
    description?: string; // use this if you only want to add a string
    input?: InputProps;
    inputType?: "password";
    loading?: boolean;
    showModal?: boolean;
    textColour?: string;
  };

export const Modal = ({
  className,
  content,
  dataTestId,
  description,
  footer,
  input,
  inputType,
  loading,
  maskClosable,
  okText,
  showModal,
  textColour,
  title,
  onOk,
  okButtonProps,
  productEvent,
  productEventProperties,
  ...props
}: ModalProps) => {
  const handleOnOkClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    trackMixpanel("ConfirmModalConfirm", { type: title });
    if (productEvent) productAnalytics.track(productEvent, productEventProperties);
    onOk?.(e);
  };

  return (
    <AntModal
      data-testid={dataTestId}
      className={`modalconfirm-modal ${className || ""}`}
      centered
      maskClosable={!!maskClosable}
      onOk={handleOnOkClick}
      okButtonProps={okButtonProps || { "data-testid": `${dataTestId}-ok` }}
      cancelButtonProps={{ "data-testid": `${dataTestId}-cancel` }}
      okText={<div className="white-text">{okText}</div>}
      title={
        <Typography variant="h5" className={textColour}>
          {title}
        </Typography>
      }
      open={showModal}
      footer={loading ? null : footer}
      zIndex={props.zIndex || 1003}
      {...props}
    >
      {loading ? (
        <PageSpin fullHeight={false} />
      ) : (
        <>
          {content ?? (
            <Typography variant="paragraph-m" className={textColour}>
              {description}
            </Typography>
          )}
          {/* @ts-expect-error need to convert to tsx */}
          {input ? inputType === "password" ? <InputPassword {...input} /> : <Input {...input} /> : null}
        </>
      )}
    </AntModal>
  );
};

export default Modal;
